import axios from "axios";

// Points at the B2B Travel CRM module mounted under /crm in silvanaGo_backend
// (app.js -> app.use('/crm', require('./src/routes'))). Same host as the
// main API (see src/app/api.js), different port (backend's CRM router runs
// on the app's PORT, currently 3005). Override with REACT_APP_CRM_API_URL
// in a .env file if the backend runs elsewhere.
export const CRM_BASE_URL =
  process.env.REACT_APP_CRM_API_URL || "http://server.voyasiadmc.com/crm/api/v1/";

const CRM_STORAGE_KEY = "crmAuth";

export const getCrmAuth = () => {
  try {
    const raw = localStorage.getItem(CRM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const setCrmAuth = (auth) => {
  if (auth) {
    localStorage.setItem(CRM_STORAGE_KEY, JSON.stringify(auth));
  } else {
    localStorage.removeItem(CRM_STORAGE_KEY);
  }
};

const crmAxios = axios.create({ baseURL: CRM_BASE_URL });

crmAxios.interceptors.request.use((config) => {
  const auth = getCrmAuth();
  if (auth?.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`;
  }
  return config;
});

let isRefreshing = false;
let pendingQueue = [];

const flushQueue = (error, token) => {
  pendingQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve(token);
  });
  pendingQueue = [];
};

crmAxios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config || {};
    const isAuthCall =
      originalRequest.url?.includes("auth/login") ||
      originalRequest.url?.includes("auth/refresh-token") ||
      originalRequest.url?.includes("auth/register");

    if (error.response?.status !== 401 || isAuthCall || originalRequest._retry) {
      return Promise.reject(error);
    }

    const auth = getCrmAuth();
    if (!auth?.refreshToken) {
      setCrmAuth(null);
      window.location.href = "/crm/login";
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return crmAxios(originalRequest);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const { data } = await axios.post(`${CRM_BASE_URL}auth/refresh-token`, {
        refreshToken: auth.refreshToken,
      });
      const newAuth = { ...auth, ...data.data };
      setCrmAuth(newAuth);
      flushQueue(null, newAuth.accessToken);
      originalRequest.headers.Authorization = `Bearer ${newAuth.accessToken}`;
      return crmAxios(originalRequest);
    } catch (refreshErr) {
      flushQueue(refreshErr, null);
      setCrmAuth(null);
      window.location.href = "/crm/login";
      return Promise.reject(refreshErr);
    } finally {
      isRefreshing = false;
    }
  }
);

export { crmAxios };
